import axios from "axios";
import {BaseResponse} from "../../BaseResponse";

export async function postHistory(data: FormData) {
    const response = await axios.post<BaseResponse<String>>("/tank/certificate/file", data, {
        headers: {"Content-Type": "multipart/form-data"}
    })

    return response.data
}